const useTransformarIniciales = (datos) => {
  if (!datos) return {};

  const transformarArray = (campo) => {
    if (!campo) return [];
    if (Array.isArray(campo)) return campo.map((e) => e.id.toString());
    if (campo.id) return [campo.id.toString()];
    return [];
  };

  return {
    ...datos,
    estadoId: datos.estado?.id?.toString() || "",
    titulacionPrincipalId: datos.titulacionPrincipal?.id?.toString() || "",
    situacionProfesionalId: datos.situacionProfesional?.id?.toString() || "",
    habilitacionId: datos.habilitacion?.id?.toString() || "",
    tipoPagoId: datos.tipoPago?.id?.toString() || "",
    colegioId: datos.colegio?.id?.toString() || "",
    delegacionId: datos.delegacion?.id?.toString() || "",
    gradoCarreraId: datos.gradoCarrera?.id?.toString() || "",
    paisNacimientoId: datos.paisNacimiento?.id?.toString() || "",
    pais: datos.pais?.id?.toString() || "",
    nacionalidad: datos.nacionalidad?.toString() || "",
    sexo: datos.sexo?.toString() || "",

    especialidadesIds: transformarArray(datos.especialidades),
    funcionesIds: transformarArray(datos.funciones),
    premiosIds: transformarArray(datos.premios),
    lugaresTrabajoIds: transformarArray(datos.lugaresTrabajo),

    iban: datos.iban || "",
  };
};

export default useTransformarIniciales;
